import { Component } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { DeliveryItem, PreviousStatusItem, TicketItem } from 'src/app/api/models';
import { DeliveryService, TicketService } from 'src/app/api/services';

@Component({
  selector: 'app-modal-correct-status',
  templateUrl: './modal-correct-status.component.html',
  styleUrls: ['./modal-correct-status.component.scss'],
})
export class ModalCorrectStatusComponent {
  status?: { id: number; label: string };
  ticket?: TicketItem;
  delivery?: DeliveryItem;
  type!: 'ticket' | 'delivery';
  previousStatuses: PreviousStatusItem[] = [];
  loading = true;

  correctStatusForm = new FormGroup({
    previous_status: new FormControl<PreviousStatusItem | undefined>(undefined, Validators.required),
  });

  constructor(
    public ref: DynamicDialogRef,
    public config: DynamicDialogConfig,
    private ticketService: TicketService,
    private deliveryService: DeliveryService
  ) {
    this.status = config.data.status;
    this.ticket = config.data.ticket;
    this.delivery = config.data.delivery;
  }

  ngOnInit() {
    if (this.ticket) {
      this.type = 'ticket';
      this.ticketService.ticketControllerFindTicketPreviousStatuses({ id: +this.ticket.id }).subscribe({
        next: res => {
          this.previousStatuses = res.data.list;
          this.loading = false;
        },
        error: () => {
          this.loading = false;
        },
      });
    } else if (this.delivery) {
      this.type = 'delivery';
      this.deliveryService
        .deliveryControllerFindDeliveryPreviousStatuses({ id: +this.delivery.id })
        .subscribe({
          next: res => {
            this.previousStatuses = res.data.list;
            this.loading = false;
          },
          error: () => {
            this.loading = false;
          },
        });
    }
  }

  close() {
    this.ref.close();
  }

  save() {
    this.ref.close({
      value: this.correctStatusForm.value.previous_status,
    });
  }
}
